import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import { ControlledCheckbox } from "@saleor/components/ControlledCheckbox";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import { getFormErrors, getProductErrorMessage } from "@saleor/utils/errors";
import React from "react";
import { useIntl } from "react-intl";

interface CollectionPopupMessageProps {
  data: {
    popupMessage: string;
    enablePopupMessage: boolean;
  };
  disabled: boolean;
  errors: ProductErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

const CollectionPopupMessage = ({
  data,
  disabled,
  errors,
  onChange
}: CollectionPopupMessageProps) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["popupMessage"], errors);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Product Popup Message",
          description: "Popup Message header"
        })}
      />
      <CardContent>
        <ControlledCheckbox
          checked={data.enablePopupMessage}
          label={intl.formatMessage({
            defaultMessage: "Enable Popup Message",
            description: "Enable Popup Message, switch button"
          })}
          name={"enablePopupMessage" as keyof FormData}
          onChange={onChange}
        />
        {data.enablePopupMessage && (
          <>
            <TextField
              disabled={disabled}
              error={!!formErrors.popupMessage}
              helperText={getProductErrorMessage(formErrors.popupMessage, intl)}
              name={"popupMessage" as keyof FormData}
              onChange={onChange}
              label={intl.formatMessage({
                defaultMessage: "Popup Message",
                description: "Popup Message,Text"
              })}
              value={data.popupMessage}
              fullWidth
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
export default CollectionPopupMessage;
